module.exports = __webpack_public_path__ + "img/rfc_file_example.570ac237.svg";